function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#757575;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 -0.015)"
}, React.createElement("g", {
  transform: "translate(58.2 13.698)"
}, React.createElement("path", {
  className: "a",
  d: "M358.418,99.14h0l-9.747-21.287h-9.438a15.456,15.456,0,0,1-2.205,5.274h5.843L335.539,99.14h-4.463V103.3a15.9,15.9,0,0,0,31.8,0V99.14h-4.463Zm-17.079,0,5.639-12.316,5.639,12.316Z",
  transform: "translate(-331.076 -77.853)"
})), React.createElement("g", {
  transform: "translate(0 13.698)"
}, React.createElement("path", {
  className: "a",
  d: "M27.342,99.14,20.01,83.127h5.843a15.463,15.463,0,0,1-2.205-5.274H14.21L4.463,99.14H0V103.3a15.9,15.9,0,0,0,31.8,0V99.14Zm-17.079,0L15.9,86.824,21.542,99.14Z",
  transform: "translate(0 -77.853)"
})), React.createElement("g", {
  transform: "translate(18.139 77.709)"
}, React.createElement("rect", {
  className: "a",
  width: 53.728,
  height: 12.306
})), React.createElement("g", {
  transform: "translate(38.85 32.43)"
}, React.createElement("path", {
  className: "a",
  d: "M227.151,190.561,221,184.408v40.005H233.3V184.408Z",
  transform: "translate(-220.998 -184.408)"
})), React.createElement("g", {
  transform: "translate(28.569 0.015)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("path", {
  className: "a",
  d: "M192.35,3.05a10.4,10.4,0,0,0-13.4-1.087,10.378,10.378,0,0,0-13.4,15.763l13.4,13.4,13.4-13.4A10.389,10.389,0,0,0,192.35,3.05Z",
  transform: "translate(-162.518 -0.015)"
}))));

var SvgHonestyImg = function SvgHonestyImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 90.005,
    height: 90,
    viewBox: "0 0 90.005 90",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHonestyImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/honesty_img.68c5e16b.svg";
export { ForwardRef as ReactComponent };